import { render, staticRenderFns } from "./tour.vue?vue&type=template&id=57988e9c&scoped=true"
import script from "./tour.vue?vue&type=script&lang=js"
export * from "./tour.vue?vue&type=script&lang=js"
import style0 from "./tour.vue?vue&type=style&index=0&id=57988e9c&prod&scoped=true&lang=scss"
import style1 from "./tour.vue?vue&type=style&index=1&id=57988e9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57988e9c",
  null
  
)

export default component.exports